export default __webpack_public_path__ + "static/media/lisaPet1.2753ead6.jpg";